import { format, formatDistanceToNow, parse } from 'date-fns';
import { IOrgConfig } from '../types';

export class OrbConfigUtilsService {


	public static checkOrbTokens = (input: string, orbConfig: IOrgConfig): string => {
		let s = input;
		// Check for all tokens
		s = this.replaceText(s, '{OrgTypeLabel}', orbConfig.OrgTypeLabel);
		s = this.replaceText(s, '{OrgTypeLabelP}', orbConfig.OrgTypeLabelP);
		s = this.replaceText(s, '{OrgTypeMgrLabel}', orbConfig.OrgTypeMgrLabel);
		s = this.replaceText(s, '{OrgTypeMgrLabelP}', orbConfig.OrgTypeMgrLabelP);
		s = this.replaceText(s, '{OrgL1Label}', orbConfig.OrgL1Label);
		s = this.replaceText(s, '{OrgL1LabelP}', orbConfig.OrgL1LabelP);
		s = this.replaceText(s, '{OrgMgrL1Lable}', orbConfig.OrgMgrL1Lable);
		s = this.replaceText(s, '{OrgMgrL1LabelP}', orbConfig.OrgMgrL1LabelP);
		s = this.replaceText(s, '{OrgL2Label}', orbConfig.OrgL2Label);
		s = this.replaceText(s, '{OrgL2LabelP}', orbConfig.OrgL2LabelP);
		s = this.replaceText(s, '{OrgMgrL2Lable}', orbConfig.OrgMgrL2Lable);
		s = this.replaceText(s, '{OrgMgrL2LabelP}', orbConfig.OrgMgrL2LabelP);
		s = this.replaceText(s, '{OrgL3Label}', orbConfig.OrgL3Label);
		s = this.replaceText(s, '{OrgL3LabelP}', orbConfig.OrgL3LabelP);
		s = this.replaceText(s, '{OrgMgrL3Lable}', orbConfig.OrgMgrL3Lable);
		s = this.replaceText(s, '{OrgMgrL3LabelP}', orbConfig.OrgMgrL3LabelP);
		return s;
	};

	public static replaceText = (input: string, searchText: string, replaceText: string): string => {
		if (!input || !searchText) return input;
		return input.split(searchText).join(replaceText);
	};


}